/**
 * @description: This file contains the constant data for the profile page.
 */
export const genders = [
  { id: 1, gender: 'Male', value: 'male' },
  { id: 2, gender: 'Female', value: 'female' },
  { id: 3, gender: 'Other', value: 'other' },
  { id: 4, gender: 'Prefer not to say', value: 'not_say' },
];
